// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type MandantenListe } from "../../api";
import { useSearchMandanten as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export type MandantenQuery = {
  search?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useMandantenQueryKey(query: MandantenQuery = {}): QueryKey {
  return ["api", "v1", "mandanten", query];
}

export function useMandanten(
  query: MandantenQuery = {},
  options: Omit<
    UseQueryOptions<MandantenListe, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): MandantenListe {
  const getter = useGetter();
  return useQuery(useMandantenQueryKey(query), () => getter(query), options)
    .data!;
}
